import { PublisherForm } from 'modules/publishers-settings/components/publisher-modal/publisher-form/publisher-form';

export { PublisherForm };
